export default {
  "member": "Member",
  "staff": "Staff",
  "external": "External",
  "unableToLoadBoardMembers": "Unable to load board members",
  "pleaseTryAgainShortly": "Please try again shortly.",
  "pleaseUploadAnImageFile": "Please upload an image file.",
  "imageMustBe5MBOrSmaller": "Image must be 5MB or smaller.",
  "nameIsRequired": "Name is required.",
  "pleaseSelectAMemberFromSearch": "Please select a member from search.",
  "pleaseSelectAStaffRecordFromSearch": "Please select a staff record from search.",
  "enterAValidEmailAddress": "Enter a valid email address.",
  "boardMemberAdded": "Board member added",
  "theRosterHasBeenUpdatedSuccessfully": "The roster has been updated successfully.",
  "unableToAddBoardMember": "Unable to add board member",
  "pleaseReviewTheDetailsAndTryAgain": "Please review the details and try again.",
  "unableToUpdateStatus": "Unable to update status",
  "pleaseTryAgain": "Please try again.",
  "roleTitleIsTooLong": "Role title is too long",
  "roleTitleMustBe80CharactersOrFewer": "Role title must be 80 characters or fewer.",
  "roleUpdated": "Role updated",
  "boardMemberRoleHasBeenUpdated": "Board member role has been updated.",
  "unableToUpdateRole": "Unable to update role",
  "boardMemberRemoved": "Board member removed",
  "theBoardRosterHasBeenUpdated": "The board roster has been updated.",
  "unableToRemoveBoardMember": "Unable to remove board member",
  "roster": "Roster",
  "boardMembers": "Board Members",
  "manageTheDirectorsOfficersAndExternalAdvisorsWhoShapeGovernanceDecisions": "Manage the directors, officers, and external advisors who shape governance decisions.",
  "addBoardMember": "Add board member",
  "buildYourGovernanceRoster": "Build your governance roster",
  "addBoardDirectorsStaffLiaisonsOrExternalAdvisorsToPrepareForSecureVoting": "Add board directors, staff liaisons, or external advisors to prepare for secure voting.",
  "trackMemberTypeRoleTitlesAndAccessStatusInOnePremiumRoster": "Track member type, role titles, and access status in one premium roster.",
  "activeRoster": "Active roster",
  "keepTheBoardRosterCurrentForSecureGovernanceAndFutureVotingWorkflows": "Keep the board roster current for secure governance and future voting workflows.",
  "role": "Role",
  "type": "Type",
  "contact": "Contact",
  "status": "Status",
  "actions": "Actions",
  "boardMember": "Board member",
  "active": "Active",
  "inactive": "Inactive",
  "boardMemberActions": "Board member actions",
  "editRole": "Edit role",
  "delete": "Delete",
  "memberType": "Member type",
  "selectType": "Select type",
  "selectFromTheMemberDirectory": "Select from the member directory.",
  "selectFromTheStaffDirectory": "Select from the staff directory.",
  "enterManuallyAndOptionallyUploadAnAvatar": "Enter manually and optionally upload an avatar.",
  "roleTitle": "Role title",
  "chairTreasurer": "Chair, Treasurer",
  "name": "Name",
  "searchStaffNameOrEmail": "Search staff name or email",
  "searchMemberNameOr": "Search member name or #",
  "clearSelection": "Clear selection",
  "type2CharactersToSearch": "Type 2+ characters to search",
  "loading": "Loading...",
  "noResults": "No results",
  "janeCarter": "Jane Carter",
  "email": "Email",
  "optionalDirectorySelectionCanPrefillThis": "Optional. Directory selection can prefill this.",
  "avatarImage": "Avatar image",
  "avatarPreview": "Avatar preview",
  "uploadJPGPNGGIFOrWebPUpTo5MB": "Upload JPG, PNG, GIF, or WebP up to 5MB.",
  "clearUploadedOverride": "Clear uploaded override",
  "boardMemberRecordsAreScopedToThisClubTenant": "Board member records are scoped to this club tenant.",
  "cancel": "Cancel",
  "saving": "Saving...",
  "addMember": "Add member",
  "memberAvatar": "Member avatar",
  "avatarUnavailable": "Avatar unavailable",
  "close": "Close",
  "upTo80CharactersLeaveEmptyToClear": "Up to 80 characters. Leave empty to clear.",
  "save": "Save",
  "removeBoardMember": "Remove board member?",
  "thisCanBeUndoneByAnAdmin": "This can be undone by an admin.",
  "removing": "Removing...",
  "remove": "Remove",
  "revenue": "Revenue",
  "expenses": "Expenses",
  "yTDRevenue": "YTD Revenue",
  "memberEngagement": "Member Engagement",
  "activeMembersThisMonth": "Active members this month",
  "openSafetyIncidents": "Open Safety Incidents",
  "requiresBoardReview": "Requires board review",
  "financialOverview": "Financial Overview",
  "revenueBreakdown": "Revenue Breakdown",
  "noRevenueDataYet": "No revenue data yet",
  "monthlyRevenueTrend": "Monthly Revenue Trend",
  "noMonthlyRevenueDataYet": "No monthly revenue data yet",
  "topExpenseCategories": "Top Expense Categories",
  "noExpenseDataYet": "No expense data yet",
  "nA": "N/A",
  "noDecisionsRequiringAction": "No decisions requiring action",
  "whenNewMotionsAreSubmittedTheyWillAppearHere": "When new motions are submitted, they will appear here.",
  "noPriorComparisonAvailable": "No prior comparison available",
  "decisionSpotlight": "Decision Spotlight",
  "budgetApproval": "Budget approval",
  "totalBudget": "Total Budget",
  "monthlyAverage": "Monthly Average",
  "varianceVsPrior": "Variance vs Prior",
  "error": "Error",
  "validationError": "Validation Error",
  "pleaseSelectAFileAndEnterACategory": "Please select a file and enter a category.",
  "success": "Success",
  "documentUploadedSuccessfully": "Document uploaded successfully.",
  "areYouSureYouWantToDeleteThisDocument": "Are you sure you want to delete this document?",
  "documentDeletedSuccessfully": "Document deleted successfully.",
  "documentsAndPolicies": "Documents & Policies",
  "searchDocuments": "Search documents...",
  "documentCategory": "Document Category",
  "chooseFile": "Choose File",
  "uploading": "Uploading...",
  "uploadDocument": "Upload Document",
  "category": "Category",
  "version": "Version",
  "lastUpdated": "Last Updated",
  "loadingDocuments": "Loading documents...",
  "download": "Download",
  "noDocumentsFound": "No documents found.",
  "failedToLoadDocuments": "Failed to load documents.",
  "failedToUploadDocument": "Failed to upload document.",
  "failedToDeleteDocument": "Failed to delete document.",
  "meetings": "Meetings",
  "createMeeting": "Create Meeting",
  "upcomingMeetings": "Upcoming Meetings",
  "pleaseSelectAClubToViewMeetings": "Please select a club to view meetings.",
  "attendees": "attendees",
  "viewDetails": "View Details",
  "noUpcomingMeetingsScheduled": "No upcoming meetings scheduled.",
  "pastMeetings": "Past Meetings",
  "pleaseSelectAClubToViewPastMeetings": "Please select a club to view past meetings.",
  "viewMinutes": "View Minutes",
  "noPastMeetingsFound": "No past meetings found.",
  "notYetOpenForVoting": "Not yet open for voting",
  "pendingForOpenVoting": "Pending for open voting",
  "votingInProgress": "Voting in progress",
  "votingCompleted": "Voting completed",
  "submissionWithdrawn": "Submission withdrawn",
  "boardDecision": "Board decision",
  "created": "Created",
  "createdBy": "Created By",
  "boardSecretariat": "Board Secretariat",
  "yes": "Yes",
  "no": "No",
  "abstain": "Abstain",
  "youVoted": "You voted",
  "outcome": "Outcome:",
  "review": "Review",
  "openVoting": "Open Voting",
  "pendingForOpen": "Pending for Open",
  "thisMotionIsQueuedForVotingOnceLeadershipOpensTheBallotWindow": "This motion is queued for voting once leadership opens the ballot window.",
  "closes": "Closes",
  "boardPackSummary": "Board Pack Summary",
  "allocationByDepartment": "Allocation by department",
  "noAllocationDataAvailable": "No allocation data available.",
  "whatChangedVsLastYear": "What changed vs last year?",
  "noPriorVersionFound": "No prior version found.",
  "overallVariance": "Overall variance",
  "topIncreases": "Top increases",
  "noIncreasesToHighlight": "No increases to highlight.",
  "topDecreases": "Top decreases",
  "noDecreasesToHighlight": "No decreases to highlight.",
  "votingManagement": "Voting Management",
  "openAndCloseVotingWindowsForBoardMembers": "Open and close voting windows for board members.",
  "resendInvites": "Resend Invites",
  "closeVoting": "Close Voting",
  "governanceRecord": "Governance Record",
  "unableToLoadMotionReviewData": "Unable to load motion review data.",
  "votingOpened": "Voting opened",
  "boardVotingIsNowLive": "Board voting is now live.",
  "unableToOpenVoting": "Unable to open voting",
  "inviteSent": "Invite sent",
  "inviteRefreshed": "Invite refreshed",
  "votingLinkAndOTPResent": "Voting link and OTP resent.",
  "inviteTokenRefreshedForThisVoter": "Invite token refreshed for this voter.",
  "inviteNotRequired": "Invite not required",
  "thisMemberVotesInTheMembersPortal": "This member votes in the Members Portal.",
  "missingEmail": "Missing email",
  "noEmailIsAvailableForThisBoardMember": "No email is available for this board member.",
  "unableToResendInvite": "Unable to resend invite",
  "votingClosed": "Voting closed",
  "theResolutionHasBeenFinalized": "The resolution has been finalized.",
  "unableToCloseVoting": "Unable to close voting",
  "backToVoting": "Back to Voting",
  "motionNotFound": "Motion not found.",
  "motionCreated": "Motion created",
  "motionOpened": "Motion opened",
  "voteRecorded": "Vote recorded",
  "motionClosed": "Motion closed",
  "motionApproved": "Motion approved",
  "motionRejected": "Motion rejected",
  "motionWithdrawn": "Motion withdrawn",
  "budgetLocked": "Budget locked",
  "budgetUnlocked": "Budget unlocked",
  "budgetCreated": "Budget created",
  "noGovernanceEventsRecordedYet": "No governance events recorded yet.",
  "board": "Board",
  "vote": "Vote:",
  "votingWindow": "Voting window",
  "unit": "Unit",
  "hours": "hours",
  "days": "days",
  "weeks": "weeks",
  "months": "months",
  "setHowLongBoardVotingRemainsOpen": "Set how long board voting remains open.",
  "boardMembersWithMembersPortalAccess": "Board members with Members Portal access",
  "theseMembersWillVoteInsideTheMembersPortalVotingTab": "These members will vote inside the Members Portal voting tab.",
  "loadingRoster": "Loading roster…",
  "unableToLoadRoster": "Unable to load roster.",
  "noPortalEnabledBoardMembersFound": "No portal-enabled board members found.",
  "boardMembersWithoutMembersPortalAccess": "Board members without Members Portal access",
  "theseMembersWillReceiveATemporaryVotingLinkAndOneTimeCodeViaEmail": "These members will receive a temporary voting link and one-time code via email.",
  "noEmailOnFile": "No email on file",
  "everyoneHasPortalAccess": "Everyone has portal access.",
  "resendVotingInvites": "Resend voting invites",
  "confirm": "Confirm",
  "votingPanel": "Voting Panel",
  "pendingForOpenVotingOpenThisMotionToBeginBoardVoting": "Pending for open voting. Open this motion to begin board voting.",
  "castYourVoteYourSelectionIsRecordedInstantly": "Cast your vote. Your selection is recorded instantly.",
  "voteYes": "Vote Yes",
  "voteNo": "Vote No",
  "resolution": "Resolution",
  "approved": "Approved",
  "membersPortal": "Members Portal",
  "emailLinkOTP": "Email link + OTP",
  "voters": "Voters",
  "loadingVoters": "Loading voters…",
  "method": "Method",
  "lastSent": "Last sent",
  "notVoted": "Not voted",
  "resendVotingLinkOTP": "Resend voting link + OTP",
  "noVotersFound": "No voters found.",
  "unableToLoadMotions": "Unable to load motions",
  "pleaseTryAgainInAFewMoments": "Please try again in a few moments.",
  "openForVoting": "Open for Voting",
  "closedResolution": "Closed resolution",
  "withdrawnMotion": "Withdrawn motion",
  "viewResolution": "View Resolution",
  "reviewMotion": "Review Motion",
  "votingAndResolutions": "Voting & Resolutions",
  "reviewBudgetMotionsOpenVotingAndRecordBoardDecisions": "Review budget motions, open voting, and record board decisions.",
  "queuedForGMSecretaryRelease": "Queued for GM/Secretary release",
  "activeBoardDecisions": "Active board decisions",
  "loadingOpenMotions": "Loading open motions…",
  "noMotionsAreCurrentlyOpenForVoting": "No motions are currently open for voting.",
  "closedMotions": "Closed Motions",
  "finalizedResolutions": "Finalized resolutions",
  "loadingClosedMotions": "Loading closed motions…",
  "noClosedMotionsYet": "No closed motions yet.",
  "refreshMotions": "Refresh motions",
  "draft": "Draft",
  "open": "Open",
  "closed": "Closed",
  "withdrawn": "Withdrawn",
  "rejected": "Rejected",
  "viewAvatar": "View avatar for {name}",
  "memberStatus": "Active status for {name}",
  "votedChoice": "Voted {choice}",
  "closesRelative": "Closes {time}",
  "selectedWindow": "the selected window",
  "openedWindow": "Voting opened — closes in {window}.",
  "motionCountOne": "{count} total motion",
  "motionCountMany": "{count} total motions",
  "yoy": "{percent} from last year",
  "other": "Other",
  "uncategorized": "Uncategorized",
  "unavailable": "Financial data unavailable. Please try again later.",
  "meetingLoadFailed": "Unable to load meetings. Please try again.",
  "emailSubject": "Vote now: {title}",
  "emailHeading": "Board voting now open",
  "emailMotion": "Motion:",
  "emailCloses": "Closes:",
  "emailHelp": "Use the link below to cast your vote. You'll be asked for the one-time code.",
  "emailCode": "One-time code:",
  "emailDeadline": "the voting deadline",
  "missing_email": "Missing email",
  "no_member_match": "No matching member record",
  "portal_access_disabled": "Portal access disabled",
  "missing_auth0_id": "Portal account unavailable",
  "loadingOpenVotes": "Loading open votes…",
  "unableToLoadVotingMotions": "Unable to load voting motions.",
  "boardVoting": "Board voting",
  "openMotions": "Open motions",
  "reviewCurrentMotionsAndCastYourVoteBeforeTheDeadline": "Review current motions and cast your vote before the deadline.",
  "noOpenMotionsRightNow": "No open motions right now.",
  "votes": "votes ·",
  "notYetVoted": "Not yet voted",
  "reviewAndVote": "Review & Vote",
  "loadingMotion": "Loading motion…",
  "unableToLoadMotionDetails": "Unable to load motion details.",
  "motionReview": "Motion review",
  "opens": "Opens",
  "yourVoteNotRecordedYet": "Your vote not recorded yet",
  "motionTotals": "Motion totals",
  "votesSoFar": "Votes so far",
  "governanceTimeline": "Governance timeline",
  "timelineUpdatesWillAppearHere": "Timeline updates will appear here.",
  "castYourVote": "Cast your vote",
  "unableToRecordVotePleaseTryAgain": "Unable to record vote. Please try again.",
  "boardVotingAccess": "Board voting access",
  "verifyYourVotingAccess": "Verify your voting access",
  "thisVotingLinkIsMissingItsAccessToken": "This voting link is missing its access token.",
  "enterYourOneTimeCode": "Enter your one-time code",
  "useTheCodeFromYourEmailToUnlockTheBallot": "Use the code from your email to unlock the ballot.",
  "6DigitCode": "6-digit code",
  "verifying": "Verifying…",
  "verify": "Verify",
  "unableToVerifyTheCodePleaseTryAgain": "Unable to verify the code. Please try again.",
  "motionDetails": "Motion details",
  "votesRecorded": "Votes recorded:",
  "motionSubmitted": "Motion submitted",
  "attendeeCountOne": "{count} attendee",
  "attendeeCountMany": "{count} attendees"
}
